var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"combo_slider"},[_c('perfect-scrollbar',[_c('div',{staticClass:"combo_slider_list"},_vm._l((_vm.items),function(val,i){return _c('ComboSliderCard',{key:`csloder-combo-${ i }`,attrs:{"item":val}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }